var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGuestPhoto(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.35,
    y: 0.35,
    width: 99.3,
    height: 99.3,
    rx: 49.65,
    fill: "white",
    stroke: "#E5E5E5",
    strokeWidth: 0.7
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.0002 50.0002C54.6043 50.0002 58.3335 46.271 58.3335 41.6668C58.3335 37.0627 54.6043 33.3335 50.0002 33.3335C45.396 33.3335 41.6668 37.0627 41.6668 41.6668C41.6668 46.271 45.396 50.0002 50.0002 50.0002ZM50.0002 54.1668C44.4377 54.1668 33.3335 56.9585 33.3335 62.5002V66.6668H66.6668V62.5002C66.6668 56.9585 55.5627 54.1668 50.0002 54.1668Z",
    fill: "#CBD3DB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuestPhoto);
export default __webpack_public_path__ + "static/media/guest-photo.1ada120c2d0f76916b2f6e9651edee0e.svg";
export { ForwardRef as ReactComponent };